import { getFunctions, httpsCallable } from 'firebase/functions';

export type EventParticipantRole = 'observer' | 'content' | 'trainer' | 'class_support' | 'evaluator' | 'other';

export type EventParticipant = {
  userId: string;
  role: EventParticipantRole;
  note?: string;
  addedAt?: unknown;
  addedBy?: string;
  compensation?: {
    billable: boolean;
    rateType?: 'hourly' | 'flat';
    rateCents?: number;
  };
};

export async function addEventParticipant(params: {
  eventId: string;
  squadId: string;
  participant: Omit<EventParticipant, 'addedAt' | 'addedBy'>;
}): Promise<void> {
  const fn = httpsCallable(getFunctions(), 'addEventParticipant');
  await fn(params);
}

export async function removeEventParticipant(params: { eventId: string; squadId: string; userId: string }): Promise<void> {
  const fn = httpsCallable(getFunctions(), 'removeEventParticipant');
  await fn(params);
}
